(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["designmyweb-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('invalid', (event) => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;
    const panel = field.closest('.dmw-contact__panel');
    if (!panel) return;

    field.setCustomValidity('');
    if (field.validity.valueMissing) field.setCustomValidity(panel.dataset.requiredMessage || '');
    else if (field.validity.typeMismatch) field.setCustomValidity(panel.dataset.emailMessage || '');
    else if (!field.validity.valid) field.setCustomValidity(panel.dataset.invalidMessage || '');
  }, true);

  document.addEventListener('input', (event) => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;
    if (field.closest('.dmw-contact__panel')) field.setCustomValidity('');
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
